export default __webpack_public_path__ + "static/product-tech-log-7aa95e807ef38e57efa55669b703e952.svg";